import { Typography, Box } from '@mui/material';
import { assetEventsPropTypes } from 'routes/history-page/history-content/prop-types/prop-types';

const AssetAccordionDetails = ({ history }) => {
  return (
    <Box aria-label="asset-accordion-details">
      {history.eventType.endsWith('asset.created') && (
        <Box
          sx={theme => ({
            pb: theme.spacing(0.5),
          })}
          aria-label="asset-created-details"
        >
          <Typography variant="body2">Asset was created.</Typography>
        </Box>
      )}
      {history.eventType.endsWith('asset.updated') && (
        <Box
          sx={theme => ({
            pb: theme.spacing(0.5),
          })}
          aria-label="asset-updated-details"
        >
          <Typography variant="body2">
            {`${'Asset renamed to '} `}
            <Typography
              variant="body2"
              component="span"
              sx={{ fontWeight: 'bold' }}
            >
              {history.name}
            </Typography>
          </Typography>
        </Box>
      )}
      {history.eventType.endsWith('asset.removed') && (
        <Box
          sx={theme => ({
            pb: theme.spacing(0.5),
          })}
          aria-label="asset-removed-details"
        >
          <Typography variant="body2">Asset was deleted.</Typography>
        </Box>
      )}
    </Box>
  );
};

AssetAccordionDetails.propTypes = {
  history: assetEventsPropTypes.isRequired,
};

export default AssetAccordionDetails;
